import {CHOOSE_NO_PLAN, CHOOSE_PLAN} from 'action_types/commonActionTypes';
import initialState from './initialState';
import helper from './reducerHelper';

const planSelectReducer = (state = initialState.plan, action: string) => {
  return helper.handleActions(state, action, {
    [CHOOSE_PLAN](state, payload) {
      state.selected = payload;
    },
    [CHOOSE_NO_PLAN](state) {
      state.selected = null;
    }
  });
};

export default planSelectReducer;
